// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@bg/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

promotionCodeFormStyles.applyButton = {
    css: css`
        position: absolute;
        top: 28px;
        height: 32px;
        padding: 0 15px;
        min-height: 30px;
        max-height: 30px;
        right: 3px;
    `,
};
